import type * as React from 'react';
import { getFile } from '@Domain/Api';
import organizationLogoFetched, {
	type OrganizationLogoFetchedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoFetched';
import organizationLogoFetchFailed, {
	type OrganizationLogoFetchFailedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoFetchFailed';
import type FetchOrganizationLogo from '@Application/Branding/OrganizationLogo/Queries/FetchOrganizationLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import readBlobAsDataUrl from '@Infra/DataUrl/readBlobAsDataUrl';
import parameters from '../../../parameters';

type Actions = OrganizationLogoFetchedAction | OrganizationLogoFetchFailedAction;

export default (query: FetchOrganizationLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const { blob } = await getFile(
				`${parameters.api.host}/api/organizations/${query.organizationId}/logo`,
			);
			// A 204 yields an empty Blob: no logo at this level.
			const dataUrl = blob.size === 0 ? null : await readBlobAsDataUrl(blob);

			const action = organizationLogoFetched({ dataUrl }, query.organizationId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationLogoFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
